import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/banner.png'
import _imports_1 from '@/assets/banner2.png'
import _imports_2 from '@/assets/banner3.png'


const _hoisted_1 = { class: "homepage-container" }
const _hoisted_2 = {
  autoplay: "",
  class: "banner-container"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "banner"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "banner1"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "banner2"
}, null, -1)
const _hoisted_6 = { class: "banner-text" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { class: "font-bold text-white text-headline mb-4" }, "海量精彩设计 一键生成", -1)
const _hoisted_8 = { class: "welcome-container" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "my-1 text-lg" }, "海量H5模板"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500" }, "一键生成，一分钟轻松制作")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "my-1 text-lg" }, "模板市场"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500" }, "支持下载各种模板")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "my-1 text-lg" }, "图片上传"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500" }, "自定义模板图片")
], -1)
const _hoisted_12 = {
  key: 0,
  class: "content-container"
}
const _hoisted_13 = {
  key: 1,
  class: "h-80 flex justify-center items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_carousel = _resolveComponent("a-carousel")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_html5_outlined = _resolveComponent("html5-outlined")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_block_outlined = _resolveComponent("block-outlined")!
  const _component_cloud_upload_outlined = _resolveComponent("cloud-upload-outlined")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_template_list = _resolveComponent("template-list")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_carousel, { "autoplay-speed": 3500 }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_a_input_search, {
          value: _ctx.searchText,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
          placeholder: "搜索一下，快速找模板",
          "enter-button": "",
          onSearch: _ctx.onSearch
        }, null, 8, ["value", "onSearch"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            span: 8,
            class: "text-center py-5"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_html5_outlined, { style: { color: '#1890ff', fontSize: '60px' } }),
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            span: 8,
            class: "text-center py-5"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_block_outlined, { style: { color: '#1890ff', fontSize: '60px' } }),
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            span: 8,
            class: "text-center py-5"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_cloud_upload_outlined, { style: { color: '#1890ff', fontSize: '60px' } }),
              _hoisted_11
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_spin, { spinning: _ctx.isLoading }, {
      default: _withCtx(() => [
        (_ctx.testData.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_template_list, { list: _ctx.testData }, null, 8, ["list"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, {
                type: "flex",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  (!_ctx.isLastPage)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "primary",
                        size: "large",
                        loading: _ctx.isLoading,
                        onClick: _ctx.loadMorePage
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 加载更多 ")
                        ]),
                        _: 1
                      }, 8, ["loading", "onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_a_empty)
            ]))
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}